import ManagerHeader from "./ManagerHeader.js";
import FileUploader from "./FileUploader.tsx";

const LessonUpload = () => {
	return (
		<>
			<ManagerHeader />
			<div className="upload-lesson">
				<FileUploader />
			</div>
		</>
	);
}

export default LessonUpload;